var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "237642AF-2BF8-4AC0-9897-92467C3D8422")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Permatrol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Responsive_1",
    transform: "translate(-18.000000, -2327.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(11.000000, 2278.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,49 C18.5522847,49 19,49.4477153 19,50 L19,64 C19,64.5522847 18.5522847,65 18,65 L8,65 C7.44771525,65 7,64.5522847 7,64 L7,50 C7,49.4477153 7.44771525,49 8,49 L18,49 Z M13.5,62 L12.5,62 C12.2238576,62 12,62.2238576 12,62.5 C12,62.7761424 12.2238576,63 12.5,63 L12.5,63 L13.5,63 C13.7761424,63 14,62.7761424 14,62.5 C14,62.2238576 13.7761424,62 13.5,62 L13.5,62 Z M16,51 L10,51 C9.48716416,51 9.06449284,51.3860402 9.00672773,51.8833789 L9,52 L9,60 C9,60.5128358 9.38604019,60.9355072 9.88337887,60.9932723 L10,61 L16,61 C16.5128358,61 16.9355072,60.6139598 16.9932723,60.1166211 L17,60 L17,52 C17,51.4477153 16.5522847,51 16,51 Z",
    id: "telefono"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.7584ed2f.svg";
export { ForwardRef as ReactComponent };